"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClaims = void 0;
const ethers_1 = require("ethers");
/**
 * Retrieves the claims from an array of objects and organizes them into a record.
 * Each claim is associated with its corresponding signatures and derived key ID.
 *
 * @param claims - An array of objects representing the claims.
 * @returns A record where each key represents a claim, and the value is an object containing the claim's signatures and derived key ID.
 */
const getClaims = (claims) => {
    const keys = Object.keys(claims[0]);
    const signatures = {};
    const claimRes = {};
    for (let i = 0; i < keys.length; i++) {
        const claimSet = claims.map((c) => c[keys[i]]);
        signatures[keys[i]] = [];
        claimSet.map((c) => {
            const sig = ethers_1.ethers.utils.splitSignature(`0x${c.signature}`);
            const convertedSig = {
                r: sig.r,
                s: sig.s,
                v: sig.v,
            };
            signatures[keys[i]].push(convertedSig);
        });
        claimRes[keys[i]] = {
            signatures: signatures[keys[i]],
            derivedKeyId: claimSet[0].derivedKeyId,
        };
    }
    return claimRes;
};
exports.getClaims = getClaims;
//# sourceMappingURL=get-claims.js.map